import React from "react";
import LocalSalesRep from "./local-sales-rep.jsx";
import RepLocation from "./local-rep-search.jsx";
import GoogleMap from "../google-map.jsx";
import LoaderSection from "../loader.jsx";
import DistrictRep from "./district-rep.jsx";

const LocalState = props => {
    let loader,
        error,
        salesRep,
        finalReps,
        dealerHeading,
        repHeading,
        distHeading,
        distributorArea;
    let count = 1;
    let distCount = 1;
    
    
    if (props.state.loading) loader = <LoaderSection show={true} />;
    
    //if there are no vendors in radius or api returned no results due to bad input show error message
    if (!props.state.firstLoad && !props.state.loading && ((props.state.zipcode || props.state.city || props.state.state) || props.state.submitForm)  && !props.state.dealers.length && !props.state.salesReps.length) {
        console.log(props.state.zipcode || props.state.city || props.state.state)
        error = (
            <div className="dealer-error">
                <p className="error">{props.state.errorMsg}</p>
                <a className="btn btn-outline" href="/support/customer-service">
                    {props.state.errorBtn}
                </a>
            </div>
        );
    }

    //renders sales rep component if there are any returned from api call
    if (props.state.salesReps.length) {
        salesRep = props.state.salesReps.filter(r => r.isDSM).map((item, index) => (
            <DistrictRep key={index} {...item} onVideoClick={props.onVideoClick} index={index}/>
        ));

        finalReps = (
            <div>
                <div className="sales-rep-category-container">
                    <div className="sales-rep-container">{salesRep}</div>
                </div>
            </div>
        );
    }

    if (!props.state.firstLoad && !props.state.loading && !props.state.distributors.length && !props.state.dealers.length && props.state.salesReps.length) {
        error = (
            <div className="dealer-error row">
                <p className="error">While we could not find any dealers or distributors with this search, we did find your sales representative(s).
                Please contact them with any questions.
                 </p>
                <div className="col-lg-4 text-left">
                    {finalReps}
                </div>
            </div>
        );
    }

    const distributors = props.state.distributors.length > 0 && !props.state.firstLoad && !props.state.loading
        ? props.state.distributors.map((item) => (
            <LocalSalesRep
                id={distCount++}
                account={item}
            />
        ))
        : <div className="col-lg-12">
            <p className="error">Distributor not available in this area.
              </p>
        </div>;

    if (props.state.useDistributors) {
        distHeading = (
            <div className="dealer-header-wrapper">
                <p className="local-dealer-header">
                    <span>Distributors</span>
                </p>
            </div>
        );
    }


    distributorArea = !props.state.firstLoad && !props.state.loading && props.state.useDistributors ?
        <React.Fragment>
            <div className="col-lg-8">
                {distHeading}
                <div className={`dealer-col`}>{distributors}</div>
            </div>

        </React.Fragment>
        : <React.Fragment></React.Fragment>;

    //creates component for rendering if place to buy has a category that is checked
    const dealers = props.state.dealers.map((item) => (
        <LocalSalesRep
            id={count++}
            account={item}

        />
    ));

    if (dealers.length > 0) {
        dealerHeading = (
            <div className="dealer-header-wrapper">
                <p className="local-dealer-header">
                    <span>Dealers</span>
                </p>
            </div>
        );
    }

    if (props.state.salesReps.filter(r => r.isDSM).length > 0) {
        repHeading = (
            <div className="dealer-header-wrapper">
                <p className="local-dealer-header">
                    <span>Available Contacts</span>
                </p>
            </div>
        );
    }

    //used to show or hide info box on map markers
    const showLink = props.state.showLink
        ? "dealer-address-map"
        : "dealer-address-map no-show";

    const localSearch = (
        <div>
            <RepLocation
                onChangeDistance={props.onChangeDistance}
                onChange={props.onChange}
                onSubmit={props.onSubmit}
                zipcode={props.state.zipcode}
                city={props.state.city}
                state={props.state.state}
                distance={props.state.distance}
            />
            <div className="intl-loader">{loader}</div>
            {error}
            <div>
                <GoogleMap
                    center={props.state.center}
                    zoom={props.state.zoom}
                    lat={props.state.lat}
                    lng={props.state.lng}
                    markers={props.state.dealers}
                    distPins={props.state.distributors}
                    currentCategory={props.categoryCompare}
                    distance={props.state.distance}
                    userLat={props.state.userLat}
                    userLng={props.state.userLng}
                    onChange={props.onLinkChange}
                    markerClass={showLink}
                    eventTarget={props.state.eventTarget}
                    firstLoad={props.state.firstLoad}
                    prevLat={props.state.prevLat}
                    prevLng={props.state.prevLng}
                    _onChange={props._onChange}
                    searchType={props.state.searchType}
                    wtb={true}
                />
            </div>

            <div className="row dealer-info-row">
                {distributorArea}

                <div className="col-lg-8">
                    {dealerHeading}
                    <div className={`dealer-col`}>{dealers}</div>
                </div>
                <div className="col-lg-4">
                    {repHeading}
                    {finalReps}
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {localSearch}
        </div>
    );
};

export default LocalState;
